export default __webpack_public_path__ + "static/media/mo.dbb9c5b1.jpg";